import { create } from 'zustand';
import { University, Document, Email, Deadline, UserProfile } from '@/types';

interface AppState {
  // User
  user: UserProfile | null;
  setUser: (user: UserProfile | null) => void;

  // Universities (synced from Firestore)
  universities: University[];
  setUniversities: (universities: University[]) => void;

  // Documents (synced from Firestore)
  documents: Document[];
  setDocuments: (documents: Document[]) => void;

  // Emails (synced from Firestore)
  emails: Email[];
  setEmails: (emails: Email[]) => void;

  // Deadlines (synced from Firestore)
  deadlines: Deadline[];
  setDeadlines: (deadlines: Deadline[]) => void;

  // UI State
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;

  // Clear all per-student data (call on StudentDetail unmount)
  clearStudentData: () => void;
}

export const useAppStore = create<AppState>()((set) => ({
  // User
  user: null,
  setUser: (user) => set({ user }),

  // Universities (synced from Firestore)
  universities: [],
  setUniversities: (universities) => set({ universities }),

  // Documents (synced from Firestore)
  documents: [],
  setDocuments: (documents) => set({ documents }),

  // Emails (synced from Firestore)
  emails: [],
  setEmails: (emails) => set({ emails }),

  // Deadlines (synced from Firestore)
  deadlines: [],
  setDeadlines: (deadlines) => set({ deadlines }),

  // UI State
  sidebarOpen: true,
  setSidebarOpen: (open) => set({ sidebarOpen: open }),

  // Reset all per-student data to empty arrays
  clearStudentData: () => set({ universities: [], documents: [], deadlines: [], emails: [] }),
}));
